import RefreshIcon from "@mui/icons-material/Refresh";
import { Alert, Box, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ManagementUnit, UpdateManagementUnitRequest } from "../../../types/model/managementUnit";
import ManagementUnitInfo from "../ManagementUnitInfo";

interface GeneralTabProps {
  managementUnitData?: ManagementUnit;
  onUpdate: (values: UpdateManagementUnitRequest) => Promise<any>;
  isPending?: boolean;
  isUpdating?: boolean;
  isError?: boolean;
  error?: any;
  handleError?: any;
  refetch?: any;
}

const GeneralTab: React.FC<GeneralTabProps> = ({ managementUnitData, onUpdate, isPending, isUpdating, isError, error, handleError, refetch }) => {
  
  const { t } = useTranslation();

  useEffect(() => {
    if (!handleError) return;
    if (isError) handleError(error);
  }, [isError]);

  if (isPending && !managementUnitData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError && !managementUnitData) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Alert
          severity="error"
          action={
            <IconButton onClick={() => refetch()} color="inherit" size="small">
              <RefreshIcon />
            </IconButton>
          }
        >
          {t("generic.errors.something-went-wrong")}
        </Alert>
      </Box>
    );
  }

  if (!managementUnitData) return null;

  return (
    <ManagementUnitInfo
      entityId={Number(managementUnitData.entityId)}
      managementUnitData={managementUnitData}
      onSubmit={onUpdate}
      isUpdating={isUpdating}
    />
  );
};

export default GeneralTab;
